import Chip from '@material-ui/core/Chip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles(theme => ({
    billable: {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
    },
    total: {
        backgroundColor: theme.palette.grey.A700,
        color: theme.palette.grey['50'],
    },
    [theme.breakpoints.down('xs')]: {
        root: {
            fontSize: '0.65rem',
        },
    },
}));

type OwnProps = {
    minutes : number;
    billable : boolean;
};

type Props = OwnProps;

const TimeChip : React.FC<Props> = ({minutes, billable} : Props) => {
    const classes = useStyles();
    const hours = Math.floor(minutes / 60);
    const minutesRemaining = minutes % 60;

    return (
        <Tooltip title={billable ? 'Billable' : 'Total'}>
            <Chip
                className={classNames(classes.root, billable ? classes.billable : classes.total)}
                label={`${hours}:${minutesRemaining.toString().padStart(2, '0')}`}
                size="small"
            />
        </Tooltip>
    );
};

export default TimeChip;
